export default __webpack_public_path__ + "static/pesout-a9bf0dfb0be2d8c372f8844845e4002b.png";